var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4123 6.0762C14.4123 8.52373 12.4499 10.4862 10.0007 10.4862C7.55223 10.4862 5.589 8.52373 5.589 6.0762C5.589 3.62868 7.55223 1.66699 10.0007 1.66699C12.4499 1.66699 14.4123 3.62868 14.4123 6.0762ZM10.0007 18.3337C6.38596 18.3337 3.33398 17.7462 3.33398 15.4795C3.33398 13.212 6.40514 12.6453 10.0007 12.6453C13.6162 12.6453 16.6673 13.2328 16.6673 15.4995C16.6673 17.767 13.5962 18.3337 10.0007 18.3337Z",
    fill: "#CFC8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProfile);
export default __webpack_public_path__ + "static/media/new_profile.e7d079a9646bb46a45295b9900b0d507.svg";
export { ForwardRef as ReactComponent };